import config from 'config';
import { isDevelopmentMode } from 'utils/helpers';
import { hotjar } from 'react-hotjar';
import Logger from 'utils/logger';

declare global {
  interface Window {
    hj?: (...args: unknown[]) => void;
    _hjSettings?: { hjid: number; hjsv: number };
  }
}

const HotjarUtils = {
  shouldSkip() {
    return !config.HOTJAR_ID || !config.HOTJAR_SNIPPET_VERSION;
  },
  loadScript() {
    try {
      if (this.shouldSkip()) {
        Logger.log('Skipping Hotjar script load');
        return;
      }

      const hotjarId = parseInt(config.HOTJAR_ID);
      const hotjarSnippetVersion = parseInt(config.HOTJAR_SNIPPET_VERSION);

      window.hj =
        window.hj ||
        function (...args: unknown[]) {
          ((window.hj as any).q = (window.hj as any).q || []).push(args);
        };
      window._hjSettings = {
        hjid: hotjarId,
        hjsv: hotjarSnippetVersion,
      };

      const script = document.createElement('script');
      script.async = true;
      script.src =
        'https://static.hotjar.com/c/hotjar-' +
        hotjarId +
        '.js?sv=' +
        hotjarSnippetVersion;
      document.head.appendChild(script);
    } catch (e) {
      Logger.error(e);
    }
  },
  trackEvent(event: string) {
    try {
      if (this.shouldSkip() || isDevelopmentMode()) {
        return;
      }

      return hotjar.event(event);
    } catch (e) {
      Logger.error(e);
    }
  },
  eventKey: {
    trialLogin: 'trial-login',
    profileSelectorOpen: 'profile-selector-open',
    profileSelectorAddProfileClick: 'add-profile-in-selector',
    addProfileClickInAddNewDropdown: 'add-profile-in-add-new',
  },
};

export default HotjarUtils;
